<template>
  <div class="app-container">
    <div class="app-content">
      <el-card class="energy-report" shadow="never">
        <template slot="header">
          <el-form inline size="small">
            <el-form-item :label="$t('text.lb')">
              <el-button-group>
                <el-button :type="dateType==='day'? 'primary': ''" @click="dateType='day'">{{ $t('text.r') }}</el-button>
                <el-button :type="dateType==='month'? 'primary': ''" @click="dateType='month'">{{ $t('text.y') }}</el-button>
                <el-button :type="dateType==='year'? 'primary': ''" @click="dateType='year'">{{ $t('text.n') }}</el-button>
              </el-button-group>
            </el-form-item>
            <el-form-item :label="$t('text.shijian')">
              <el-date-picker v-show="dateType==='day'" v-model="queryParams.time" type="date" style="margin-top: 0;" />
              <el-date-picker v-show="dateType==='month'" v-model="queryParams.time" type="month" style="margin-top: 0;" />
              <el-date-picker v-show="dateType==='year'" v-model="queryParams.time" type="year" style="margin-top: 0;" />
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-video-play" type="primary" @click="handleQuery">{{ $t('button.yl') }}</el-button>
              <el-button icon="el-icon-download" type="warning" @click="handleExport">{{ $t('button.dc') }}</el-button>
            </el-form-item>
          </el-form>
        </template>
        <template slot="default">
          <div class="content-container">
            <!-- 日报表 -->
            <template v-if="dateType==='day'">
              <div v-if="report" class="overview-container">
                <!-- 日报表 摘要信息 -->
                <el-descriptions :column="5">
                  <template slot="title">
                    <span style="color: var(--primary-color);">{{ $t('text.gailan') }}</span>
                  </template>
                  <el-descriptions-item :label="$t('text.dzmc')">
                    {{ tableData.stationName }}
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('text.rfadl')">
                    {{ tableData.dayEnergy | objValue(['f','cvalue'], 0) }} {{ tableData.dayEnergy | objValue(['f','cvalue'], 1) }}
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('text.rfdl')">
                    {{ tableData.dayEnergy | objValue(['r','cvalue'], 0) }} {{ tableData.dayEnergy | objValue(['r','cvalue'], 1) }}
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('text.rhdl')">
                    {{ tableData.dayEnergy | objValue(['c','cvalue'], 0) }} {{ tableData.dayEnergy | objValue(['c','cvalue'], 1) }}
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('text.zjrl')">
                    {{ tableData.capacity }} kWp
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('text.zfdl')">
                    {{ tableData.totalEnergy | objValue(['f','cvalue'], 0) }} {{ tableData.totalEnergy | objValue(['f','cvalue'], 1) }}
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('text.zfangdl')">
                    {{ tableData.totalEnergy | objValue(['r','cvalue'], 0) }} {{ tableData.totalEnergy | objValue(['r','cvalue'], 1) }}
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('text.zhdl')">
                    {{ tableData.totalEnergy | objValue(['c','cvalue'], 0) }} {{ tableData.totalEnergy | objValue(['c','cvalue'], 1) }}
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('text.shijian')">
                    {{ tableData.nowTime }}
                  </el-descriptions-item>
                </el-descriptions>
                <!-- 日报表 明细 -->
                <el-card class="detail-table__card" shadow="never">
                  <template slot="header">
                    {{ $t('text.mx') }}
                  </template>
                  <template slot="default">
                    <div v-for="data in computedTableData" :key="data.name" class="device-container">
                      <section class="device-title">
                        采集器： <span>{{ data.name.split('#')[0] }}</span>
                        <span style="margin: 0 10px;">|</span>
                        逆变器:  <span>{{ data.name.split('#')[1] }}</span>
                      </section>
                      <div class="table-container">
                        <el-table :data="data.children" size="small" :fit="false" height="500" style="width: 100%;">
                          <el-table-column :label="$t('text.gxsj')" prop="sitetime" width="140" align="center">
                            <template v-slot="scope">
                              <span>{{ scope.row.sitetime | dateFilter('yyyy/MM/dd hh:mm:ss') }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column :label="$t('text.zldy')" align="center">
                            <el-table-column
                              v-for="item in data.children[0].pvnum"
                              :key="item"
                              :label="'Vpv' + item"
                              :prop="'vpv' + item"
                              width="60"
                              align="center"
                            />
                          </el-table-column>
                          <el-table-column :label="$t('text.jldy')" align="center">
                            <el-table-column label="Vac1" prop="vac1" align="center" width="60" />
                            <el-table-column label="Vac2" prop="vac2" align="center" width="60" />
                            <el-table-column label="Vac3" prop="vac3" align="center" width="60" />
                          </el-table-column>
                          <el-table-column :label="$t('text.pinlv')" prop="fac" align="center" width="60" />
                          <el-table-column :label="$t('text.gl')" prop="pac" align="center" width="60" />
                          <el-table-column :label="$t('text.wdu')" prop="temperature" align="center" width="60" />
                          <el-table-column :label="$t('text.zdl')" prop="etotal" align="center" width="60" />
                        </el-table>
                      </div>
                    </div>
                  </template>
                </el-card>
              </div>
            </template>
            <!-- 月报表 -->
            <template v-if="dateType==='month'">
              <div v-if="report" class="overview-container">
                <!-- 月报表 摘要信息 -->
                <el-descriptions :column="5">
                  <template slot="title">
                    <span style="color: var(--primary-color);">{{ $t('text.gailan') }}</span>
                  </template>
                  <el-descriptions-item :label="$t('text.dzmc')">
                    {{ tableData.stationName }}
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('text.yfadl')">
                    {{ tableData.monthEnergy | objValue(['f','cvalue'], 0) }} {{ tableData.monthEnergy | objValue(['f','cvalue'], 1) }}
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('text.yfdl')">
                    {{ tableData.monthEnergy | objValue(['r','cvalue'], 0) }} {{ tableData.monthEnergy | objValue(['r','cvalue'], 1) }}
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('text.yhdl')">
                    {{ tableData.monthEnergy | objValue(['c','cvalue'], 0) }} {{ tableData.monthEnergy | objValue(['c','cvalue'], 1) }}
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('text.zjrl')">
                    {{ tableData.capacity }} kWp
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('text.zfdl')">
                    {{ tableData.totalEnergy | objValue(['f','cvalue'], 0) }} {{ tableData.totalEnergy | objValue(['f','cvalue'], 1) }}
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('text.zfangdl')">
                    {{ tableData.totalEnergy | objValue(['r','cvalue'], 0) }} {{ tableData.totalEnergy | objValue(['r','cvalue'], 1) }}
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('text.zhdl')">
                    {{ tableData.totalEnergy | objValue(['c','cvalue'], 0) }} {{ tableData.totalEnergy | objValue(['c','cvalue'], 1) }}
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('text.shijian')">
                    {{ tableData.nowTime }}
                  </el-descriptions-item>
                </el-descriptions>
                <!-- 月报表 明细 -->
                <el-card class="detail-table__card" shadow="never">
                  <template slot="header">
                    {{ $t('text.mx') }}
                  </template>
                  <template slot="default">
                    <el-table :data="tableData.energys">
                      <el-table-column :label="$t('text.shijian')" align="center">
                        <template v-slot="scope">
                          <span>{{ scope.row.time | dateFilter('yyyy-MM-dd') }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('text.rdl')" prop="val1" align="center" />
                    </el-table>
                  </template>
                </el-card>
              </div>
            </template>
            <!-- 年报表 -->
            <template v-if="dateType==='year'">
              <div v-if="report" class="overview-container">                <!-- 年报表 摘要信息 -->
                <el-descriptions :column="5">
                  <template slot="title">
                    <span style="color: var(--primary-color);">{{ $t('text.gailan') }}</span>
                  </template>
                  <el-descriptions-item :label="$t('text.dzmc')">{{ tableData.stationName }}</el-descriptions-item>
                  <el-descriptions-item :label="$t('text.nfdl')">
                    {{ tableData.yearEnergy | objValue(['f','cvalue'], 0) }} {{ tableData.yearEnergy | objValue(['f','cvalue'], 1) }}
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('text.nfangdl')">
                    {{ tableData.yearEnergy | objValue(['r','cvalue'], 0) }} {{ tableData.yearEnergy | objValue(['r','cvalue'], 1) }}
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('text.nhdl')">
                    {{ tableData.yearEnergy | objValue(['c','cvalue'], 0) }} {{ tableData.yearEnergy | objValue(['c','cvalue'], 1) }}
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('text.zjrl')">
                    {{ tableData.capacity }} kWp
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('text.zfdl')">
                    {{ tableData.totalEnergy | objValue(['f','cvalue'], 0) }} {{ tableData.totalEnergy | objValue(['f','cvalue'], 1) }}
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('text.zfangdl')">
                    {{ tableData.totalEnergy | objValue(['r','cvalue'], 0) }} {{ tableData.totalEnergy | objValue(['r','cvalue'], 1) }}
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('text.zhdl')">
                    {{ tableData.totalEnergy | objValue(['c','cvalue'], 0) }} {{ tableData.totalEnergy | objValue(['c','cvalue'], 1) }}
                  </el-descriptions-item>
                  <el-descriptions-item :label="$t('text.shijian')">
                    {{ tableData.nowTime }}
                  </el-descriptions-item>
                </el-descriptions>
                <!-- 年报表 明细 -->
                <el-card class="detail-table__card" shadow="never">
                  <template slot="header">
                    {{ $t('text.mx') }}
                  </template>
                  <template slot="default">
                    <el-table :data="tableData.energys">
                      <el-table-column :label="$t('text.shijian')" align="center">
                        <template v-slot="scope">
                          <span>{{ scope.row.time | dateFilter('yyyy-MM') }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('text.yfadl')" prop="val1" align="center" />
                      <el-table-column :label="$t('text.yfdl')" prop="val2" align="center" />
                      <el-table-column :label="$t('text.yhdl')" prop="val3" align="center" />
                    </el-table>
                  </template>
                </el-card>
              </div>
            </template>
          </div>
        </template>
      </el-card>
    </div>
  </div>
</template>

<script>
import { GetDayReportData, GetMYReportData, ExpReport } from '@apis/Statistics.js'
import { getMonthLength } from '@utils'
import dayjs from 'dayjs'
export default {
  components: {
  },
  data () {
    return {
      fullLoading: null,
      dateType: 'day',
      queryParams: {
        time: dayjs().format('YYYY-MM-DD')
      },
      tableData: {},
      report: false
    }
  },
  computed: {
    computedTableData () {
      const arr = []
      if (this.tableData.historyData) {
        Object.keys(this.tableData.historyData).forEach(key => {
          const o = {}
          o.name = key
          o.children = this.tableData.historyData[key]
          arr.push(o)
        })
      }
      return arr
    }
  },
  watch: {
    dateType () {
      this.report = false
      this.tableData = {}
    }
  },
  methods: {
    // 预览
    handleQuery () {
      this.fullLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let mask1 = ''
      let mask2 = ''
      if (this.dateType === 'day') {
        mask1 = 'yyyy-MM-dd 00:00:00'
        mask2 = 'yyyy-MM-dd 23:59:59'
      } else if (this.dateType === 'month') {
        const l = getMonthLength(this.queryParams.time)
        mask1 = 'yyyy-MM-01 00:00:00'
        mask2 = 'yyyy-MM-' + l + ' 23:59:59'
      } else if (this.dateType === 'year') {
        mask1 = 'yyyy-01-01 00:00:00'
        mask2 = 'yyyy-12-31 23:59:59'
      }
      if (this.dateType === 'day') {
        GetDayReportData({
          startTime: this.$parseTime(this.queryParams.time, mask1),
          endTime: this.$parseTime(this.queryParams.time, mask2),
          orgId: this.$store.getters.station.id
        })
          .then(res => {
            this.report = true
            this.fullLoading.close()
            this.tableData = res.data
          })
          .catch(() => {
            this.fullLoading.close()
          })
      } else {
        GetMYReportData({
          dateType: this.dateType,
          startTime: this.$parseTime(this.queryParams.time, mask1),
          endTime: this.$parseTime(this.queryParams.time, mask2),
          orgId: this.$store.getters.station.id
        }).then(res => {
          this.report = true
          this.fullLoading.close()
          this.tableData = res.data
        })
          .catch(() => {
            this.fullLoading.close()
          })
      }
    },
    // 导出
    handleExport () {
      this.fullLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let mask1 = ''
      let mask2 = ''
      if (this.dateType === 'day') {
        mask1 = 'yyyy-MM-dd 00:00:00'
        mask2 = 'yyyy-MM-dd 23:59:59'
      } else if (this.dateType === 'month') {
        const l = getMonthLength(this.queryParams.time)
        mask1 = 'yyyy-MM-01 00:00:00'
        mask2 = 'yyyy-MM-' + l + ' 23:59:59'
      } else if (this.dateType === 'year') {
        mask1 = 'yyyy-01-01 00:00:00'
        mask2 = 'yyyy-12-31 23:59:59'
      }
      ExpReport({
        dateType: this.dateType,
        startTime: this.$parseTime(this.queryParams.time, mask1),
        endTime: this.$parseTime(this.queryParams.time, mask2),
        orgId: this.$store.getters.station.id
      })
        .then(res => {
          this.fullLoading.close()
          window.location.href = res.data
        })
        .catch(() => {
          this.fullLoading.close()
        })
    }
  }
}
</script>
<style scoped>
.energy-report{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color:var(--card-bg-color);
  border-color:var(--card-bg-color);
}

.energy-report >>> .el-card__header{
  width: 100%;
  height: 50px;
  padding: 0 15px;
  box-sizing: border-box;
}
.energy-report >>> .el-card__header .el-form{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.energy-report >>> .el-card__header .el-form .el-form-item{
  margin-bottom: 0;
}

.energy-report >>> .el-card__body{
  width: 100%;
  height: calc(100% - 50px);
  padding: 0 15px 10px;
  box-sizing: border-box;
}
.energy-report >>> .el-card__body .content-container{
   width: 100%;
   height: 100%;
   padding: 0;
   box-sizing: border-box;
}
.energy-report >>> .el-card__body .content-container .overview-container{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
}
.energy-report>>>.el-card__body .content-container .overview-container .el-descriptions{
  width: 100%;
  height: 85px;
  padding: 0;
  box-sizing: border-box;
}
.energy-report>>>.el-card__body .content-container .overview-container .el-descriptions .el-descriptions__header {
  width: 100%;
  height: 30px;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin-bottom: 0;
}
.energy-report>>>.el-card__body .content-container .overview-container .el-descriptions .el-descriptions__body{
  width: 100%;
  height: calc(100% - 30px);
  padding: 0;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-bg-color);
}
.energy-report>>>.el-card__body .content-container .overview-container .el-descriptions .el-descriptions__body{
  width: 100%;
  height: calc(100% - 30px);
  padding: 0;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-bg-color);
}
.energy-report>>>.el-card__body .content-container .overview-container .el-descriptions .el-descriptions__body .el-descriptions-item__label,
.energy-report>>>.el-card__body .content-container .overview-container .el-descriptions .el-descriptions__body .el-descriptions-item__content{
  color: var(--primary-color);
}

.energy-report>>>.el-card__body .content-container .overview-container .detail-table__card{
  width: 100%;
  height: calc(100% - 85px);
  padding: 0;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-bg-color);
}
.energy-report>>>.el-card__body .content-container .overview-container .detail-table__card .el-card__header{
  width: 100%;
  height: 30px;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: var(--primary-color);
}

.energy-report>>>.el-card__body .content-container .overview-container .detail-table__card .el-card__body{
  width: 100%;
  height: calc(100% - 30px);
  padding: 0;
  box-sizing: border-box;
  overflow: auto;
}
.energy-report>>>.el-card__body .content-container .overview-container .detail-table__card .el-card__body .device-container {
  width: 100%;
  height: auto;
  padding: 0;
  box-sizing: border-box;
  border: thin solid var(--primary-color);
  margin-top: 10px;
}
.energy-report>>>.el-card__body .content-container .overview-container .detail-table__card .el-card__body .device-title {
  width: 100%;
  height: 30px;
  padding: 0 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: white;
}
.energy-report>>>.el-card__body .content-container .overview-container .detail-table__card .el-card__body .table-container{
  width: 100%;
  height: auto;
  padding: 0;
  box-sizing: border-box;
  overflow: auto;
}
.energy-report>>>.el-card__body .content-container .overview-container .detail-table__card .el-card__body .table-container .el-table {
 border: none;
}
.energy-report>>>.el-card__body .content-container .overview-container .detail-table__card .el-card__body .table-container .el-table::after {
 background-color: transparent;
}
.energy-report>>>.el-card__body .content-container .overview-container .detail-table__card .el-card__body .table-container .el-table--border th.el-table__cell.gutter:last-of-type{
 border: none;
}
</style>

